export default "/images/20af5aa85bb827b4778526b44e6a6922.png";